import React from 'react';

import { SearchTextField, TabMenu, PopoverMenu, Avatar, View } from 'src/components/basic';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import Call from 'src/components/call';
import callModel from 'src/components/call/model';
import AnalysesList from 'src/components/analyse/list';
import TimelineList from 'src/components/timeline/list';
import TreatmentsList from 'src/components/treatments/list';
import { DoctorInfoPanel, PatientInfoPanel } from 'src/components/complex';

import { remCss, userFullName, withRouter } from 'src/helpers';

import model from 'src/components/messages/model';

import Chat from 'src/components/messages/chat';
import ContactsList from 'src/components/messages/ContactsList';
import analysesModel from 'src/components/messages/analysesModel';
import timelineModel from 'src/components/messages/timelineModel';
import treatmentsModel from 'src/components/messages/treatmentsModel';
import filesModel from 'src/components/messages/filesModel';
import BaseMessage, { tabs, list } from 'src/components/messages';
import { getUnavailableStateForNow } from 'src/helpers';
import { ActivityLabel } from 'src/components/user/LastActivity';
import { FreeChatForContact } from 'components/messages/ProfilePopup';

export class Message extends BaseMessage {
  render() {
    const { contactUser } = model.state;
    const callUUID = callModel.state.current;
    const { isCaller, callerId } = callModel.getListState(callUUID);
    const isCalling = callUUID && (isCaller || callerId == contactUser?.id);

    const activeTab = model.getTab('main_message');
    return (
      <div className={'mc-container-content mc-messages'}>
        {/*<div className={'mc-container-content__header mc-flex-15'}>*/}
        {/*  <span className={'mc-grow'}>{lang.t('Messages')}</span>*/}
        {/*</div>*/}
        <div
          className={'mc-container-content__header mc-flex-15'}
          style={{ width: '30%', maxWidth: remCss(330) }}
        >
          <SearchTextField
            width={330}
            template={'2'}
            onChange={model.handleChangeSearch2}
            value={model.listInput('search')}
          />
        </div>
        <div className={'mc-container-content__body horizontal'} style={{ position: 'relative' }}>
          <div
            className={'mc-container-content__body-left mc-b2r'}
            style={{ maxWidth: remCss(330), minWidth: remCss(330) }}
          >
            <ContactsList />
          </div>
          <div
            data-testid='messages-chat-panel'
            className={'mc-container-content__body-center'}
            style={{ minWidth: remCss(510) }}
          >
            <div className={'mc-header ' + (isCalling ? 'has-calling' : '')}>
              <Call />
              {contactUser && (
                <div className={'mc-flex mc-p20 mc-flex-start'}>
                  <Avatar
                    image={(contactUser?.avatar || '').replace('/full_', '/350_')}
                    width={50}
                    height={50}
                    text={userFullName(contactUser)}
                    onlineState={
                      getUnavailableStateForNow(contactUser?.accountState)
                        ? 'not_available'
                        : contactUser.partnerOnline > 0
                          ? 'online'
                          : ''
                    }
                  />
                  <div className={'mc-flex-5-col mc-grow'}>
                    <div className={'mc-value-520'}>
                      {userFullName(contactUser, contactUser.isDoctor)}
                    </div>
                    <div className={'mc-label-516'} data-testid={'message-contact-status'}>
                      <ActivityLabel
                        accountState={contactUser?.accountState}
                        lastActivity={contactUser?.lastActivity}
                        connections={contactUser?.partnerOnline}
                      />
                    </div>
                  </div>
                  <div className={'mc-flex-10'} style={{ height: remCss(40) }}>
                    <button type='button' className={'mc-no-style-btn'} onClick={this.toggleSearch}>
                      <SVGIcon iconname={BASE_ICONS.SEARCH} width={40} />
                    </button>
                    {!isCalling && (
                      <button
                        data-testid='message-call-button'
                        type='button'
                        className={'mc-no-style-btn'}
                        onClick={this.startCall}
                      >
                        <SVGIcon iconname={BASE_ICONS.VIDEO} width={40} />
                      </button>
                    )}
                    <PopoverMenu
                      placement={'bottom-end'}
                      menu={(close) => (
                        <ul
                          className={'mc-select-field-items'}
                          style={{
                            backgroundColor: 'white',
                            padding: remCss(10)
                          }}
                        >
                          {list
                            .filter((item) => item.isShow(contactUser, model.state.user))
                            .map((item) => {
                              if (item.component) {
                                let Comp = item.component;
                                return (
                                  <Comp
                                    key={contactUser?.id}
                                    close={close}
                                    contactUser={contactUser}
                                    user={model.state.user}
                                  />
                                );
                              }
                              return (
                                <li
                                  key={item.label}
                                  onClick={() => {
                                    if (item.onClick) {
                                      item.onClick(contactUser);
                                    } else {
                                      this.setOption(item);
                                    }
                                    close();
                                  }}
                                >
                                  <div className={'mc-p15 mc-pointer'}>
                                    <div className={'mc-value-520'}>{item.label}</div>
                                  </div>
                                </li>
                              );
                            })}
                        </ul>
                      )}
                      className={'mc-no-style-btn'}
                    >
                      {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={40} />}
                    </PopoverMenu>
                    {model.state.hideInfo && (
                      <button
                        type='button'
                        className={'mc-no-style-btn'}
                        onClick={() => this.openRightSlide()}
                      >
                        <SVGIcon iconname={BASE_ICONS.PERSONAL_INFORMATION} width={40} />
                      </button>
                    )}
                  </div>
                </div>
              )}
              {model.state.enableSearch ? (
                <div className={'mc-search-chat-box mc-p10'}>
                  <View style={{ padding: remCss(10) }}>{this.renderSearchMessage()}</View>
                </div>
              ) : !isCalling && contactUser ? (
                <TabMenu
                  tabs={tabs}
                  tab={{ id: activeTab }}
                  setTab={model.changeMessageTab}
                  className={'mc-mobile'}
                />
              ) : (
                <div className={'mc-line'} />
              )}
            </div>
            {contactUser && (
              <div className={'mc-tab-box-opacity mc-grow'}>
                <div
                  className={
                    'mc-tab-content mc-flex-0-col ' + (activeTab === 'chat' ? '' : 'mc-inactive')
                  }
                >
                  <Chat treatmentsModel={treatmentsModel} />
                </div>
                <div
                  className={
                    'mc-tab-content mc-flex-col ' + (activeTab === 'treatment' ? '' : 'mc-inactive')
                  }
                >
                  <TreatmentsList model={treatmentsModel} showDoctor={true} />
                </div>
                <div
                  className={
                    'mc-tab-content mc-flex-col ' + (activeTab === 'analyses' ? '' : 'mc-inactive')
                  }
                >
                  <AnalysesList model={analysesModel} />
                </div>
                <div
                  className={
                    'mc-tab-content mc-flex-col ' + (activeTab === 'timeline' ? '' : 'mc-inactive')
                  }
                >
                  <TimelineList
                    selectJourney={timelineModel.selectJourney}
                    journeys={
                      timelineModel.listInput(
                        'journeys',
                        timelineModel.state.partnerId + ':recent'
                      ) || []
                    }
                    journey={timelineModel.listInput(
                      'journey',
                      timelineModel.state.partnerId + ':recent'
                    )}
                    journeyId={timelineModel.listInput(
                      'journeyId',
                      timelineModel.state.partnerId + ':recent'
                    )}
                    model={timelineModel}
                  />
                </div>
              </div>
            )}
          </div>
          <div
            ref={this.rightSliderRef}
            className={
              'mc-container-content__body-right ' +
              (model.state.hideInfo ? 'animate-close' : 'animate-open')
            }
            style={{
              width: '40%',
              maxWidth: remCss(400),
              position: 'absolute',
              right: '0px',
              zIndex: 100000,
              backgroundColor: 'white'
            }}
          >
            {contactUser &&
              (contactUser.isDoctor ? (
                <DoctorInfoPanel
                  {...contactUser}
                  doctor={contactUser}
                  closeBtn={() => this.closeRightSlide()}
                  viewProfile={this.viewProfile.bind(this, '')}
                  freeChatEl={
                    <FreeChatForContact
                      contactUser={contactUser}
                      user={model.state.user}
                      template={'profile'}
                    />
                  }
                />
              ) : (
                <PatientInfoPanel
                  patient={{ ...contactUser?.partnerProfile, id: contactUser.id }}
                  viewProfile={this.viewProfile.bind(this, '')}
                  closeBtn={() => this.closeRightSlide()}
                  model={filesModel}
                  freeChatEl={
                    <FreeChatForContact
                      contactUser={contactUser}
                      user={model.state.user}
                      template={'profile'}
                    />
                  }
                />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Message);
